import React from 'react';
import { FileText, Calendar } from 'lucide-react';
import { Card, Badge } from '../design-system';
import notesService from '../../services/notesService';

const NoteCard = ({ note, onClick }) => {
  const formattedDate = notesService.formatDateForDisplay(note.updatedAt || note.createdAt);

  return (
    <Card
      variant="default"
      padding="medium"
      className="cursor-pointer hover:shadow-md transition-shadow h-full"
      onClick={onClick}
    >
      <div className="flex items-start gap-3 h-full">
        <div className="flex-shrink-0 mt-1">
          <div className="h-10 w-10 rounded-full flex items-center justify-center" style={{backgroundColor: 'rgba(44, 166, 164, 0.1)'}}>
            <FileText className="h-5 w-5" style={{color: 'var(--color-primary)'}} />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-semibold text-gray-900 mb-1 line-clamp-1">
            {note.heading}
          </h3>
          <p className="text-sm text-gray-600 mb-2 line-clamp-2">
            {note.summary}
          </p>
          {note.tags && note.tags.length > 0 && (
            <div className="flex flex-wrap gap-1 mb-2">
              {note.tags.slice(0, 3).map((tag, index) => (
                <Badge key={index} variant="outline" size="small">
                  {tag}
                </Badge>
              ))}
              {note.tags.length > 3 && (
                <Badge variant="outline" size="small">
                  +{note.tags.length - 3}
                </Badge>
              )}
            </div>
          )}
          <div className="flex items-center gap-1 text-xs text-gray-500 mt-auto">
            <Calendar className="h-3 w-3" />
            <span>{formattedDate}</span>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default NoteCard;

